const windowScroll = async function () {
    const   headerFixed = document.querySelector('header'),
            anchors = document.querySelector('.anchors-section');

    let lastScroll = 0;
    window.addEventListener('scroll', () => {
        let currentScroll = window.pageYOffset;
        if (currentScroll > lastScroll && !headerFixed.classList.contains('header-scrolled')) {
            // scroll down
            headerFixed.classList.add('header-scrolled');
            headerFixed.classList.add('header-bg');
            if ( anchors ) { anchors.classList.add('header-hide'); }
        } else if (currentScroll < lastScroll && headerFixed.classList.contains('header-scrolled')) {

            headerFixed.classList.remove('header-scrolled');
            headerFixed.classList.add('header-bg');
            if ( anchors ) {anchors.classList.remove('header-hide');}
        }
        else if(currentScroll == 0){
            headerFixed.classList.remove('header-bg');
        }
        
        if ( anchors ) {
            anchors.querySelectorAll('a').forEach((e, i) => {
                let item = document.querySelector(e.hash);
                if ( isInViewport(item) ) {
                    e.classList.add('lg:border-opacity-100');
                } else {
                    e.classList.remove('lg:border-opacity-100');
                }
            });
        }
        lastScroll = currentScroll;
    });

    function isInViewport(element) {
        const rect = element.getBoundingClientRect();
        return (
            rect.top <= 0 &&
            rect.bottom >= 0
        );
    }

};

export const init = windowScroll;


